import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-thumbnail',
  templateUrl: './image-thumbnail.component.html',
  styleUrls: ['./image-thumbnail.component.css']
})
export class ImageThumbnailComponent {

  @Input() src: string = ''; // URL of the actual image
  @Input() placeholder: string = 'assets/icons/Anna_About.PNG'; // Default thumbnail
  @Input() alt: string = 'image'; // Alt text for the image

  currentSrc: string = this.placeholder;
  isLoaded: boolean = false;

  ngOnChanges() {
    this.currentSrc = this.placeholder;
    this.isLoaded = false;
  }

  onImageLoad() {
    this.isLoaded = true;
    this.currentSrc = this.src;
  }

  onImageError() {
    this.currentSrc = this.placeholder; // Fallback to placeholder if the image fails to load
  }

}
